import React, { createContext, useContext, useMemo, useState } from "react";

const ActiveSectionContext = createContext();

export function ActiveSectionProvider({ children }) {
  const [activeId, setActiveId] = useState(null);
  const value = useMemo(() => ({ activeId, setActiveId }), [activeId]);

  return (
    <ActiveSectionContext.Provider value={value}>
      {children}
    </ActiveSectionContext.Provider>
  );
}

export function useActiveSection() {
  const context = useContext(ActiveSectionContext);
  if (!context) {
    throw new Error("useActiveSection must be used within an ActiveSectionProvider");
  }
  return context;
}
